module.exports = __webpack_public_path__ + "static/chest--locked-aab1674e731c15f7bb8f691c2352adfd.png";